//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
import { convertToUnit } from '../utils/helpers';
import NsTabsWrapper from './NsTabsWrapper.vue';

const TAB_PADDING = 16;

export default {
  name: 'NsTabs',
  components: { NsTabsWrapper },
  props: {
    /**
     * The background color of the tab bar
     */
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    /**
     * The label and slider color when active
     */
    color: {
      type: String,
      default: undefined,
    },
    /**
     * Overrides height of the tabs
     */
    height: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Hides the slider
     */
    hideSlider: Boolean,
    /**
     * Index of the selected tab
     */
    selected: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Overrides the slider color
     */
    sliderColor: {
      type: String,
      default: undefined,
    },
    /**
     * Sets the slider width to equal the text content width
     */
    sliderWidthToContent: Boolean,
    /**
     * Fires select event on hover rather than on click
     */
    useHover: Boolean,
  },
  data() {
    return {
      selectedValue: this.selected,
      slider: {
        left: null,
        width: null,
      },
    };
  },
  computed: {
    sliderWrapperStyle() {
      return {
        height: '2px',
        left: convertToUnit(this.slider.left),
        width: convertToUnit(this.slider.width),
        color: this.sliderColor,
      };
    },
    tabsBarStyle() {
      return {
        height: convertToUnit(this.height),
        color: this.color,
        backgroundColor: this.backgroundColor,
      };
    },
  },
  watch: {
    selected(value) {
      this.selectedValue = value;
    },
    selectedValue() {
      this.callSlider();
    },
    sliderWidthToContent: 'callSlider',
  },
  mounted() {
    this.$nextTick(() => {
      window.setTimeout(this.callSlider, 30);
    });
  },
  methods: {
    async callSlider() {
      const items =
        this.$slots.default &&
        this.$slots.default.filter(
          (node) =>
            node.componentOptions && node.componentOptions.tag === 'NsTab'
        );

      if (this.hideSlider || !items || !items.length) {
        this.slider.width = null;
        return false;
      }
      // Give screen time to paint
      await this.$nextTick();

      const activeTab = items[+this.selectedValue];

      if (!(activeTab && activeTab.componentOptions)) {
        this.slider.width = null;
        this.slider.left = null;
        return;
      }

      const el = activeTab.componentOptions.children[0].elm;
      // if (!(activeTab && activeTab.elm)) {
      //   this.slider.width = 0;
      //   this.slider.left = 0;
      //   return;
      // }
      // const el = activeTab.elm;

      if (el) {
        const parentEl = el.parentNode;
        this.slider = {
          left: this.sliderWidthToContent
            ? parentEl.offsetLeft + TAB_PADDING
            : parentEl.offsetLeft,
          width: this.sliderWidthToContent
            ? parentEl.scrollWidth - TAB_PADDING * 2
            : parentEl.scrollWidth,
        };
      }

      // return true;
    },
    handleSelect(index) {
      this.selectedValue = index;
      /**
       * Emits an event when a tab is selected with params: function(index) {}
       */
      this.$emit('select', index);
    },
  },
};
